import { Auth0Client } from '@auth0/nextjs-auth0/server'
import { IncomingMessage } from 'http'
import { getOpCoAuth0Config } from './auth0.config'

const partnerInstanceCache: Record<string, Auth0Client | undefined> = {}

const createCacheKey = (authConfig: ReturnType<typeof getOpCoAuth0Config>) => {
  return `${authConfig.iataCode}:${authConfig?.config?.domain}:${authConfig?.config?.appBaseUrl}`
}

export const getAuth0Server = (req: IncomingMessage) => {
  const { config, iataCode } = getOpCoAuth0Config(req)
  const cacheKey = createCacheKey({ config, iataCode })
  const instance = partnerInstanceCache[cacheKey]
  if (instance) {
    return instance
  }
  partnerInstanceCache[cacheKey] = new Auth0Client(config)
  return partnerInstanceCache[cacheKey]
}
